import { deleteRequest, getRequest, postRequest, putRequest } from 'src/utils/http';
import { drugsController } from './consts';

export const listDrugs = async (params) => getRequest(`${drugsController}`, params);
export const createDrug = async (drug) => postRequest(`${drugsController}`, drug);
export const getDrug = async (drug) => getRequest(`${drugsController}/${drug}`);
export const updateDrug = async (drug, data) => putRequest(`${drugsController}/${drug}`, data);
export const deleteDrug = async (drug) => deleteRequest(`${drugsController}/${drug}`);
